import request from '@/utils/request'

const baseURL = '/settings/project-shape-schemas'

export default {
  getAvailableAttributes() {
    return request({
      url: `${baseURL}/available-attributes`,
      method: 'get',
      params: { _t: Date.now() },
    })
  },

  list() {
    return request({
      url: `${baseURL}`,
      method: 'get',
      params: { _t: Date.now() },
    })
  },

  get(id) {
    return request({
      url: `${baseURL}/${id}`,
      method: 'get',
      params: { _t: Date.now() },
    })
  },

  create(data) {
    return request({
      url: `${baseURL}`,
      method: 'post',
      data,
    })
  },

  update(id, data) {
    return request({
      url: `${baseURL}/${id}`,
      method: 'put',
      data,
    })
  },
}
